// extracted by mini-css-extract-plugin
export default {"bp-small":"768px","menus":"Menus-loader-module__menus___9HNV5","fake":"Menus-loader-module__fake___FasK9","fakeItem":"Menus-loader-module__fakeItem___Vk2kO"};